import { Combobox as ComboboxMantine } from '@mantine/core';
import { Search } from 'lucide-react';

export const ComboboxSearch = ComboboxMantine.Search.extend({
	defaultProps: {
		leftSection: <Search />,
		leftSectionPointerEvents: 'none',
		variant: 'default',
	},
});

export const Combobox = ComboboxMantine.extend({
	defaultProps: {
		offset: 0,
	},
});
